// pasteAsPlainText.js — shared plain-text-only paste handler for contentEditable captions.
// Strips formatting by manually inserting a text node at the current Selection/Range instead of
// the deprecated `document.execCommand('insertText', ...)`. Extracted from MapNodeChrome's and
// figureNodeView's identical caption-paste handlers (both mediaType captions share this need).

/**
 * @param {HTMLElement} containerEl — the contentEditable element the paste must land inside.
 * @param {ClipboardEvent} e
 */
export function pasteAsPlainText(containerEl, e) {
    e.preventDefault();
    const text = e.clipboardData?.getData('text/plain') || '';

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    if (!containerEl.contains(range.commonAncestorContainer)) return;

    range.deleteContents();
    const textNode = document.createTextNode(text);
    range.insertNode(textNode);

    range.setStartAfter(textNode);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
}
